// Табличные данные из ГОСТ/ПУЭ для выбора сечения кабеля

import { STANDARD_SECTIONS } from './constants';

// Тип для таблицы токов по сечениям
type CurrentTable = Record<number, number>;

// ============================================
// РЕАКТИВНОЕ СОПРОТИВЛЕНИЕ (Ом/км) ПО СЕЧЕНИЯМ
// Для кабельных линий с ПВХ/СПЭ изоляцией
// ============================================
export const X0_BY_SECTION: CurrentTable = {
  1.5: 0.104,
  2.5: 0.099,
  4: 0.093,
  6: 0.090,
  10: 0.086,
  16: 0.082,
  25: 0.078,
  35: 0.075,
  50: 0.072,
  70: 0.069,
  95: 0.066,
  120: 0.064,
  150: 0.062,
  185: 0.060,
};

// ============================================
// ДЛИТЕЛЬНО ДОПУСТИМЫЕ ТОКИ (А)
// Для кабелей с медными жилами, ПВХ изоляцией, на воздухе
// ГОСТ 31996-2012 (ПУЭ табл. 1.3.4)
// ============================================
export const I_ALLOWABLE_COPPER_PVC_AIR: CurrentTable = {
  1.5: 19,
  2.5: 27,
  4: 38,
  6: 50,
  10: 70,
  16: 90,
  25: 115,
  35: 140,
  50: 175,
  70: 215,
  95: 260,
  120: 300,
  150: 340,
  185: 390,
};

// ============================================
// ДЛИТЕЛЬНО ДОПУСТИМЫЕ ТОКИ (А)
// Для кабелей с алюминиевыми жилами, ПВХ изоляцией, на воздухе
// ГОСТ 31996-2012 (ПУЭ табл. 1.3.5)
// ============================================
export const I_ALLOWABLE_ALUMINUM_PVC_AIR: CurrentTable = {
  1.5: 15,
  2.5: 21,
  4: 30,
  6: 39,
  10: 55,
  16: 70,
  25: 90,
  35: 110,
  50: 140,
  70: 175,
  95: 210,
  120: 245,
  150: 275,
  185: 315,
};

// ============================================
// ДЛИТЕЛЬНО ДОПУСТИМЫЕ ТОКИ (А)
// Для кабелей с медными жилами, ПВХ изоляцией, в земле
// ГОСТ 31996-2012 (ПУЭ табл. 1.3.4)
// ============================================
export const I_ALLOWABLE_COPPER_PVC_GROUND: CurrentTable = {
  1.5: 27,
  2.5: 36,
  4: 48,
  6: 62,
  10: 84,
  16: 110,
  25: 143,
  35: 170,
  50: 205,
  70: 255,
  95: 300,
  120: 345,
  150: 390,
  185: 445,
};

// ============================================
// ДЛИТЕЛЬНО ДОПУСТИМЫЕ ТОКИ (А)
// Для кабелей с алюминиевыми жилами, ПВХ изоляцией, в земле
// ГОСТ 31996-2012 (ПУЭ табл. 1.3.5)
// ============================================
export const I_ALLOWABLE_ALUMINUM_PVC_GROUND: CurrentTable = {
  1.5: 21,
  2.5: 28,
  4: 37,
  6: 48,
  10: 65,
  16: 86,
  25: 110,
  35: 135,
  50: 160,
  70: 200,
  95: 235,
  120: 270,
  150: 305,
  185: 350,
};

// ============================================
// ДЛИТЕЛЬНО ДОПУСТИМЫЕ ТОКИ (А)
// Для кабелей с медными жилами, СПЭ изоляцией, в земле
// ============================================
export const I_ALLOWABLE_COPPER_XLPE_GROUND: CurrentTable = {
  1.5: 33,
  2.5: 44,
  4: 58,
  6: 75,
  10: 100,
  16: 135,
  25: 175,
  35: 210,
  50: 255,
  70: 315,
  95: 375,
  120: 430,
  150: 485,
  185: 550,
};

// ============================================
// ДЛИТЕЛЬНО ДОПУСТИМЫЕ ТОКИ (А)
// Для кабелей с алюминиевыми жилами, СПЭ изоляцией, в земле
// ============================================
export const I_ALLOWABLE_ALUMINUM_XLPE_GROUND: CurrentTable = {
  1.5: 26,
  2.5: 35,
  4: 46,
  6: 59,
  10: 79,
  16: 105,
  25: 135,
  35: 165,
  50: 200,
  70: 245,
  95: 295,
  120: 340,
  150: 385,
  185: 440,
};

// ============================================
// ДЛИТЕЛЬНО ДОПУСТИМЫЕ ТОКИ (А)
// Для кабелей с медными жилами, СПЭ изоляцией, на воздухе
// ============================================
export const I_ALLOWABLE_COPPER_XLPE_AIR: CurrentTable = {
  1.5: 24,
  2.5: 33,
  4: 46,
  6: 60,
  10: 84,
  16: 110,
  25: 140,
  35: 170,
  50: 210,
  70: 260,
  95: 320,
  120: 365,
  150: 415,
  185: 475,
};

// ============================================
// ДЛИТЕЛЬНО ДОПУСТИМЫЕ ТОКИ (А)
// Для кабелей с алюминиевыми жилами, СПЭ изоляцией, на воздухе
// ============================================
export const I_ALLOWABLE_ALUMINUM_XLPE_AIR: CurrentTable = {
  1.5: 19,
  2.5: 26,
  4: 36,
  6: 47,
  10: 65,
  16: 86,
  25: 110,
  35: 135,
  50: 165,
  70: 205,
  95: 250,
  120: 290,
  150: 325,
  185: 375,
};

// ============================================
// ТЕМПЕРАТУРНЫЕ КОЭФФИЦИЕНТЫ ДЛЯ ПВХ ИЗОЛЯЦИИ
// ПУЭ табл. 1.3.3
// ============================================
export const K_TEMP_PVC: Record<number, number> = {
  15: 1.17,
  20: 1.12,
  25: 1.06,
  30: 1.00,  // базовая для воздуха
  35: 0.94,
  40: 0.87,
  45: 0.79,
  50: 0.71,
  55: 0.61,
  60: 0.50,
};

// ============================================
// ТЕМПЕРАТУРНЫЕ КОЭФФИЦИЕНТЫ ДЛЯ СПЭ ИЗОЛЯЦИИ
// ПУЭ табл. 1.3.3
// ============================================
export const K_TEMP_XLPE: Record<number, number> = {
  15: 1.11,
  20: 1.07,
  25: 1.04,
  30: 1.00,  // базовая для воздуха
  35: 0.96,
  40: 0.91,
  45: 0.87,
  50: 0.82,
  55: 0.76,
  60: 0.71,
  65: 0.65,
  70: 0.58,
};

// ============================================
// КОЭФФИЦИЕНТЫ ПРИ ПРОКЛАДКЕ ПУЧКОМ
// ПУЭ табл. 1.3.26
// ============================================
export const K_BUNDLE: Record<number, number> = {
  1: 1.00,
  2: 0.85,
  3: 0.70,
  4: 0.65,
  5: 0.60,
  6: 0.57,
  7: 0.54,
  8: 0.52,
  9: 0.50,
  10: 0.48,
};

// ============================================
// КОЭФФИЦИЕНТЫ ДЛЯ ПРОКЛАДКИ В ЗЕМЛЕ
// ПУЭ табл. 1.3.23 - по тепловому сопротивлению грунта (К·см/Вт)
// ============================================
export const K_GROUND_RESISTANCE: Record<number, number> = {
  50: 1.14,
  80: 1.06,
  120: 1.00,  // нормальный грунт
  160: 0.95,
  200: 0.91,
  250: 0.86,
  300: 0.81,
};

// ============================================
// КОЭФФИЦИЕНТЫ ДЛЯ ПРОКЛАДКИ В ЗЕМЛЕ (упрощённые)
// По типу грунта
// ============================================
export const K_GROUND: Record<string, number> = {
  normal: 1.00,      // нормальный грунт (ρ = 120 К·см/Вт)
  wet: 1.06,         // влажный грунт (ρ = 80 К·см/Вт)
  dry: 0.91,         // сухой грунт (ρ = 200 К·см/Вт)
  veryDry: 0.86,     // очень сухой грунт (ρ = 250 К·см/Вт)
};

// ============================================
// КОЭФФИЦИЕНТЫ ДЛЯ ПРОКЛАДКИ В ТРУБЕ
// ============================================
export const K_PIPE: Record<number, number> = {
  1: 1.00,
  2: 0.90,
  3: 0.85,
  4: 0.80,
  5: 0.78,
};

// ============================================
// ВСПОМОГАТЕЛЬНЫЕ ФУНКЦИИ
// ============================================

/**
 * Получить допустимый ток для заданных условий
 */
export function getAllowedCurrent(
  crossSection: number,
  material: 'copper' | 'aluminum',
  insulationType: 'pvc' | 'xlpe',
  installationMethod: 'air' | 'ground'
): number {
  let table: CurrentTable;
  
  if (installationMethod === 'ground') {
    // Для земли выбираем таблицу по типу изоляции
    if (insulationType === 'xlpe') {
      table = material === 'copper'
        ? I_ALLOWABLE_COPPER_XLPE_GROUND
        : I_ALLOWABLE_ALUMINUM_XLPE_GROUND;
    } else {
      table = material === 'copper'
        ? I_ALLOWABLE_COPPER_PVC_GROUND
        : I_ALLOWABLE_ALUMINUM_PVC_GROUND;
    }
  } else {
    if (insulationType === 'xlpe') {
      table = material === 'copper'
        ? I_ALLOWABLE_COPPER_XLPE_AIR
        : I_ALLOWABLE_ALUMINUM_XLPE_AIR;
    } else {
      table = material === 'copper'
        ? I_ALLOWABLE_COPPER_PVC_AIR
        : I_ALLOWABLE_ALUMINUM_PVC_AIR;
    }
  }
  
  return table[crossSection] || 0;
}

/**
 * Получить температурный коэффициент с линейной интерполяцией
 */
export function getTempCoefficient(
  ambientTemp: number,
  insulationType: 'pvc' | 'xlpe'
): number {
  const table = insulationType === 'pvc' ? K_TEMP_PVC : K_TEMP_XLPE;
  const temps = Object.keys(table).map(Number).sort((a, b) => a - b);
  
  // Если температура меньше минимальной в таблице
  if (ambientTemp <= temps[0]) {
    return table[temps[0]];
  }
  
  // Если температура больше максимальной в таблице
  if (ambientTemp >= temps[temps.length - 1]) {
    return table[temps[temps.length - 1]];
  }
  
  // Линейная интерполяция между двумя ближайшими значениями
  for (let i = 0; i < temps.length - 1; i++) {
    const t1 = temps[i];
    const t2 = temps[i + 1];
    
    if (ambientTemp >= t1 && ambientTemp <= t2) {
      const k1 = table[t1];
      const k2 = table[t2];
      // Линейная интерполяция
      return k1 + (k2 - k1) * (ambientTemp - t1) / (t2 - t1);
    }
  }
  
  return 1;
}

/**
 * Получить коэффициент для пучка кабелей с интерполяцией
 */
export function getBundleCoefficient(cablesCount: number): number {
  if (cablesCount <= 1) return 1.00;
  if (cablesCount >= 10) return K_BUNDLE[10] || 0.48;
  
  // Если есть точное значение в таблице
  if (K_BUNDLE[cablesCount] !== undefined) {
    return K_BUNDLE[cablesCount];
  }
  
  // Линейная интерполяция между ближайшими значениями
  const counts = Object.keys(K_BUNDLE).map(Number).sort((a, b) => a - b);
  for (let i = 0; i < counts.length - 1; i++) {
    const c1 = counts[i];
    const c2 = counts[i + 1];
    if (cablesCount >= c1 && cablesCount <= c2) {
      const k1 = K_BUNDLE[c1];
      const k2 = K_BUNDLE[c2];
      return k1 + (k2 - k1) * (cablesCount - c1) / (c2 - c1);
    }
  }
  
  return K_BUNDLE[Math.min(cablesCount, 10)] || 0.48;
}

/**
 * Получить коэффициент для прокладки в земле по тепловому сопротивлению
 */
export function getGroundCoefficient(thermalResistance: number): number {
  const resistances = Object.keys(K_GROUND_RESISTANCE).map(Number).sort((a, b) => a - b);
  
  // Если сопротивление меньше минимального
  if (thermalResistance <= resistances[0]) {
    return K_GROUND_RESISTANCE[resistances[0]];
  }
  
  // Если сопротивление больше максимального
  if (thermalResistance >= resistances[resistances.length - 1]) {
    return K_GROUND_RESISTANCE[resistances[resistances.length - 1]];
  }
  
  // Линейная интерполяция
  for (let i = 0; i < resistances.length - 1; i++) {
    const r1 = resistances[i];
    const r2 = resistances[i + 1];
    
    if (thermalResistance >= r1 && thermalResistance <= r2) {
      const k1 = K_GROUND_RESISTANCE[r1];
      const k2 = K_GROUND_RESISTANCE[r2];
      return k1 + (k2 - k1) * (thermalResistance - r1) / (r2 - r1);
    }
  }
  
  return 1;
}

/**
 * Получить реактивное сопротивление для сечения
 */
export function getReactance(crossSection: number): number {
  return X0_BY_SECTION[crossSection] || 0.08;
}

/**
 * Найти минимальное сечение, выдерживающее заданный ток
 */
export function findMinSection(
  current: number,
  material: 'copper' | 'aluminum',
  insulationType: 'pvc' | 'xlpe',
  installationMethod: 'air' | 'ground'
): number | null {
  for (const section of STANDARD_SECTIONS) {
    const allowedCurrent = getAllowedCurrent(
      section,
      material,
      insulationType,
      installationMethod
    );
    if (allowedCurrent >= current) {
      return section;
    }
  }
  return null;
}
